import React from 'react';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { ArrowRightIcon } from '@fiverr-private/icons';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Box } from '@fiverr-private/theme';
import { getCheckoutCtaCopyKey } from './getCheckoutCtaCopy';

interface OpenDrawerButtonPentaProps {
  onClick?: () => void;
  loading?: boolean;
  isRestrictedByRegion?: boolean;
}

const OpenDrawerButtonPenta = ({
  onClick = noop,
  loading = false,
  isRestrictedByRegion = false,
}: OpenDrawerButtonPentaProps) => {
  const continueCopyKey = getCheckoutCtaCopyKey();

  return (
    <Button type="button" onClick={onClick} loading={loading} intent="primary" disabled={isRestrictedByRegion}>
      <Stack gap="2" alignItems="center" justifyContent="center" direction="row">
        <Text color="white" fontWeight="semibold">
          <I18n k={continueCopyKey} />
        </Text>
        <Box display="flex" alignItems="center">
          <ArrowRightIcon color="white" />
        </Box>
      </Stack>
    </Button>
  );
};

export default OpenDrawerButtonPenta;
